import Splide from "@splidejs/splide";

export const homeSlider = () => {
  const thumbnailsSplide = new Splide(".main-splide", {
    autoplay: true,
    rewind: true,
    perPage: 1,
    pagination: true,
    breakpoints: {
      768: {
        pagination: false,
        cover: true
      }
    }
  }).mount();

  const primarySplide = new Splide(".splide-primary", {
    autoplay: true,
    type: "fade",
    heightRatio: 0.7,
    pagination: false,
    arrows: false,
    cover: true
  });

  primarySplide.sync(thumbnailsSplide).mount();
};

export const propertieSlider = () => {
  new Splide("#properties-slider", {
    autoplay: false,
    rewind: true,
    perPage: 2,
    gap: 20,
    pagination: false,
    fixedHeight: "758px",

    breakpoints: {
      768: {
        perPage: 1,
        padding: {
          left: 0,
          right: "15rem",
          gap: 0
        }
      },
      600: {
        perPage: 1,
        padding: {
          left: 0,
          right: "5rem",
          gap: 0
        }
      },
      414: {
        perPage: 1,
        padding: {
          left: 0,
          right: 0,
          gap: 0
        }
      }
    }
  }).mount();
};

export const countrySlider = () => {
  new Splide("#country", {
    autoplay: true,
    rewind: true,
    perPage: 3,
    pagination: false,
    gap: 10,
    padding: {
      left: 0,
      right: "10rem"
    },
    breakpoints: {
      768: {
        pagination: true,
        arrows: false,
        perPage: 1,
        gap: 1,
        padding: {
          right: "17rem"
        }
      },
      600: {
        perPage: 1,
        padding: {
          left: 0,
          right: "5rem"
        }
      },
      414: {
        pagination: true,
        perPage: 1,
        padding: {
          left: 0,
          right: 0
        }
      }
    }
  }).mount();
};

export const showSlider = () => {
  new Splide("#show-sliders", {
    rewind: true,
    pagination: false,
    focus: "center",
    perPage: 2,
    gap: "1em",
    trimSpace: false,
    start: 1,
    breakpoints: {
      768: {
        arrows: false,
        pagination: true,
        perPage: 1,
        start: 0,
        gap: "10em"
      }
    }
  }).mount();
};

export const HomeHeader = () => {
  new Splide(".splide-home-header", {
    autoplay: true,
    interval: 4000,
    rewind: true,
    perPage: 1,
    pagination: true
  }).mount();
};
